import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import LandingPage from "./components/Accueil/LandingPage";
import Dashboard from "./components/Dashboard/Dashboard";
import Unauthorized from "./components/Unauthorized/Unauthorized";
import NotFound from "./components/NotFound/NotFound";
import TwoFactorAuth from "./components/Accueil/TwoFactorAuth";
import SendResetLink from "./components/Accueil/SendResetLink";
import ResetPasswordForm from "./components/Accueil/ResetPasswordForm";
import SignIn from "./components/Accueil/SignIn";
import {
  DashboardRoute,
  TwoFactorAuthRoute,
} from "./components/middleware/AuthMiddleware";
import ChatResults from "./components/Profiles/ChatResults";
import Captcha from "./components/Accueil/Captcha";
import UsersManagement from "./components/users/UsersManagement";
import AppelOffreManagement from "./components/AppelOffre/AppelOffreManagement";
import AppelOffreResults from "./components/AppelOffre/AppelOffreResults";
import LandingDashboard from "./components/Accueil/LandingDashboard";

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LandingPage />} />
        <Route path="/connexion" element={<SignIn />} />
        <Route path="/envoyer-lien" element={<SendResetLink />} />
        <Route path="/reinitialiser-mdp" element={<ResetPasswordForm />} />
        <Route path="/interdit" element={<Unauthorized />} />
        <Route path="/chat-results" element={<ChatResults />} />
        <Route path="/captcha" element={<Captcha />} />
        <Route path="/users" element={<UsersManagement />} />
        <Route path="/appel-offres" element={<AppelOffreManagement />} />
        <Route path="/appeloffre-results" element={<AppelOffreResults />} />
        <Route path="/reset-password" element={<SendResetLink />} />
        <Route path="/landingdashboard" element={<LandingDashboard />} />

        {/* /acceuil is accessible only if currentUser.status is "in use" */}
        <Route
          path="/acceuil"
          element={
            <DashboardRoute>
              <Dashboard />
            </DashboardRoute>
          }
        />

        {/* /2fa is accessible only if currentUser.status is "creation" or "chgPwd" */}
        <Route
          path="/2fa"
          element={
            <TwoFactorAuthRoute>
              <TwoFactorAuth />
            </TwoFactorAuthRoute>
          }
        />

        <Route path="*" element={<NotFound />} />
      </Routes>
    </Router>
  );
}

export default App;
